import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { useNavigate, useLocation } from '@thd-olt-component-react/router';
import { FullCompare } from '@thd-olt-component-react/compare';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

export const CompareContainer = (props) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const { storeId, isLocalized } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <QueryProvider
      cacheKey="compare-page-container"
      defaultVariables={{
        storeId,
        skipInstallServices: false,
        isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false
      }}
    >
      <FullCompare
        navigate={navigate}
        location={location}
      />
    </QueryProvider>
  );
};
